// Breadcrumb navigation component
// Created as part of ENG2-1700: Create Topbar Component

import React from 'react'
import { Box, Typography } from '@mui/material'
import { Link } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons'
import { tokens } from '../../styles/tokens'
import { BreadcrumbProps } from './topbar.types'

const Breadcrumb: React.FC<BreadcrumbProps> = ({ items }) => {
  if (!items || items.length === 0) {
    return null
  }

  return (
    <Box
      component="nav"
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        fontSize: '14px',
        color: 'text.secondary',
      }}
    >
      {items.map((item, index) => {
        const isFirst = index === 0
        const isLast = index === items.length - 1
        const isClickable = !!item.path && !isLast

        const content = (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: '4px',
              color: isLast ? 'text.primary' : 'text.secondary',
              fontWeight: isLast ? 600 : 400,
              transition: `color ${tokens.transitions.fast}`,
              ...(isClickable && {
                cursor: 'pointer',
                '&:hover': {
                  color: 'primary.main',
                },
              }),
            }}
          >
            {/* Back arrow on first item */}
            {isFirst && isClickable && (
              <FontAwesomeIcon
                icon={faArrowLeft}
                style={{ fontSize: '12px', marginRight: '4px' }}
              />
            )}
            {/* Custom icon if provided */}
            {item.icon && <Box sx={{ display: 'flex' }}>{item.icon}</Box>}
            {/* Label */}
            <Typography
              component="span"
              sx={{
                fontSize: 'inherit',
                fontWeight: 'inherit',
                color: 'inherit',
              }}
            >
              {item.label}
            </Typography>
          </Box>
        )

        return (
          <React.Fragment key={index}>
            {/* Separator */}
            {index > 0 && (
              <Box
                component="span"
                sx={{ color: 'text.disabled', display: 'flex', alignItems: 'center' }}
              >
                <FontAwesomeIcon
                  icon={faChevronRight}
                  style={{ fontSize: '10px' }}
                />
              </Box>
            )}

            {/* Breadcrumb item */}
            {isClickable && item.path ? (
              <Link to={item.path} style={{ textDecoration: 'none' }}>
                {content}
              </Link>
            ) : (
              content
            )}
          </React.Fragment>
        )
      })}
    </Box>
  )
}

export default Breadcrumb
